import { Locale } from './common/locale/locale-models';

export const DotcomFlags: Record<string, Locale> = {
  'enu-US': {
    key: 'enu-US',
    hasOlapic: true,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: true,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'zhs-US': {
    key: 'zhs-US',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: true,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'spa-US': {
    key: 'spa-US',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: true,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-AU': {
    key: 'enu-AU',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: false,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'zhs-AU': {
    key: 'zhs-AU',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: false,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-NZ': {
    key: 'enu-NZ',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: false,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'zhs-NZ': {
    key: 'zhs-NZ',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: false,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-CA': {
    key: 'enu-CA',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'fre-CA': {
    key: 'fre-CA',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'zhs-CA': {
    key: 'zhs-CA',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-GB': {
    key: 'enu-GB',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'zht-TW': {
    key: 'zht-TW',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: false,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'tha-TH': {
    key: 'tha-TH',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: false,
    hasOlivol: false,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: false,
    hasRetailShopping: true,
  },
  'zhs-SG': {
    key: 'zhs-SG',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'enu-SG': {
    key: 'enu-SG',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'enu-RO': {
    key: 'enu-RO',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'ron-RO': {
    key: 'ron-RO',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-PH': {
    key: 'enu-PH',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: true,
    hasWeightManagement: true,
    hasBlog: false,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'enu-NL': {
    key: 'enu-NL',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'fre-NL': {
    key: 'fre-NL',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-MY': {
    key: 'enu-MY',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: false,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'msa-MY': {
    key: 'msa-MY',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: false,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'zhs-MY': {
    key: 'zhs-MY',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: false,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'spa-MX': {
    key: 'spa-MX',
    hasOlapic: false,
    hasIncelligence: false,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: false,
    hasDrLee: false,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: false,
    hasRetailShopping: true,
  },
  'kor-KR': {
    key: 'kor-KR',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: false,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'enu-KR': {
    key: 'enu-KR',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: false,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'jpn-JP': {
    key: 'jpn-JP',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: false,
    hasRetailShopping: false,
  },
  'enu-JP': {
    key: 'enu-JP',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'ita-IT': {
    key: 'ita-IT',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: false,
    hasRetailShopping: true,
  },
  'enu-IT': {
    key: 'enu-IT',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'ind-ID': {
    key: 'ind-ID',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: false,
    hasRetailShopping: false,
  },
  'enu-ID': {
    key: 'enu-ID',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'zht-HK': {
    key: 'zht-HK',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'enu-HK': {
    key: 'enu-HK',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: false,
  },
  'fre-FR': {
    key: 'fre-FR',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-FR': {
    key: 'enu-FR',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-ES': {
    key: 'enu-ES',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'spa-ES': {
    key: 'spa-ES',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'deu-DE': {
    key: 'deu-DE',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-DE': {
    key: 'enu-DE',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'spa-CO': {
    key: 'spa-CO',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: false,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'nld-BE': {
    key: 'nld-BE',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'fre-BE': {
    key: 'fre-BE',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-BE': {
    key: 'enu-BE',
    hasOlapic: false,
    hasIncelligence: true,
    hasHybridTechnology: true,
    hasOlivol: true,
    hasScienceDisclaimer: false,
    hasChampions: true,
    hasDrLee: true,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
  'enu-IN': {
    key: 'enu-IN',
    hasOlapic: false,
    hasIncelligence: false,
    hasHybridTechnology: false,
    hasOlivol: false,
    hasScienceDisclaimer: true,
    hasChampions: true,
    hasDrLee: false,
    hasEnergy: false,
    hasWeightManagement: true,
    hasBlog: true,
    hasAtsSearch: true,
    hasRetailShopping: true,
  },
};
